__turbopack_context__.v({
  "skeleton": "FiltersSkeletons-module-scss-module__kK_Jja__skeleton",
  "skeleton-anim": "FiltersSkeletons-module-scss-module__kK_Jja__skeleton-anim",
});
